import { Switch } from '@mui/material';
import cc from 'classcat';

type MaterialUISwtichColorType = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default' | undefined;
type MaterialUISwtichSizeType = 'small' | 'medium' | undefined;

interface ICustomSwitch {
    checked: boolean;
    onChange: () => void;
    color?: MaterialUISwtichColorType;
    className?: string;
    disabled?: boolean;
    size?: MaterialUISwtichSizeType;
    labelText: string;
    hasInfo?: boolean;
    tooltipInfoText?: string;
}
export const CustomSwitch = ({ checked, onChange, color, className, size, labelText, hasInfo, tooltipInfoText, disabled = false }: ICustomSwitch) => {
    return (
        <div className={cc(['switch', className])}>
            <div className="switch__label">
                <p className="paragraph-3">{labelText}</p>
                {hasInfo && (
                    <div className="switch__label-info-wrapper">
                        <img className="switch__label-info-wrapper--icon" src="/svg/slider/info-icon.svg" alt="info" />
                        <p className="paragraph-5 switch__label-info-wrapper--tooltip">{tooltipInfoText}</p>
                    </div>
                )}
            </div>
            <Switch checked={checked} onChange={onChange} color={color} disabled={disabled} size={size} />
        </div>
    );
};
